import TagManager, { TagManagerArgs } from 'react-gtm-module';
import { isBetaDomain, isProdEnvironment } from 'utils/environment';

// Initialize Google Tag Manager
if (isProdEnvironment() && !isBetaDomain) {
  const tagManagerArgs: TagManagerArgs = {
    gtmId: 'GTM-M3LKWBW',
  };

  TagManager.initialize(tagManagerArgs);
}
